// user email actions
export const FETCH_USER_EMAILS_REQUEST = 'FETCH_USER_EMAILS_REQUEST';
export const FETCH_USER_EMAILS_SUCCESS = 'FETCH_USER_EMAILS_SUCCESS';
export const FETCH_USER_EMAILS_ERROR = 'FETCH_USER_EMAILS_FAILURE';
export const UPDATE_EMAIL_REQUEST = 'UPDATE_EMAIL_REQUEST';
export const UPDATE_EMAIL_SUCCESS = 'UPDATE_EMAIL_SUCCESS';
export const UPDATE_EMAIL_ERROR = 'UPDATE_EMAIL_FAILURE';
export const CREATE_EMAIL_REQUEST = 'CREATE_EMAIL_REQUEST';
export const CREATE_EMAIL_ERROR = 'CREATE_EMAIL_FAILURE';
export const CREATE_EMAIL_SUCCESS = 'CREATE_EMAIL_SUCCESS';

export const UPDATE_EMAILS_IN_STORE_ONLY = 'UPDATE_EMAILS_IN_STORE_ONLY';
